import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "../layouts/AppLayout";
import { HomePage } from "../pages/HomePage";
import { AlliancesPage } from "../pages/AlliancesPage";
import { AllianceDetailPage } from "../pages/AllianceDetailPage";
import { InfoPage } from "../pages/InfoPage";
import { ErrorsPage } from "../pages/ErrorsPage";
import { StatusPage } from "../pages/StatusPage";
import { ChangelogPage } from "../pages/ChangelogPage";
import { Routes } from "../constants";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: Routes.HOME, element: <HomePage /> },
      { path: Routes.ALLIANCES, element: <AlliancesPage /> },
      { path: Routes.INFO, element: <InfoPage /> },
      { path: Routes.ERRORS, element: <ErrorsPage /> },
      { path: Routes.STATUS, element: <StatusPage /> },
      { path: Routes.CHANGELOG, element: <ChangelogPage /> },
      { path: Routes.ALLIANCE_DETAIL, element: <AllianceDetailPage /> },
    ],
  },
]);
